import styled from "@emotion/styled";

export default styled.div`
  min-height: 700px;
  padding-top: 74px;
`;